/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// Custom web component for quantity badges selector
!function () {
  "use strict";

  /**
   * Quantity Selector Web Component
   * 
   * This component manages the selection of quantity badges and updates
   * the hidden quantity input field based on the selected badge's data-quantity attribute.
   */
  var QuantitySelector = /*#__PURE__*/function (_HTMLElement) {
    _inherits(QuantitySelector, _HTMLElement);
    var _super = _createSuper(QuantitySelector);
    function QuantitySelector() {
      var _this;
      _classCallCheck(this, QuantitySelector);
      _this = _super.call(this);
      _this.quantityInput = null;
      _this.badges = [];
      _this.selectedBadge = null;
      _this.calloutElement = null;
      _this.isUpdating = false; // Flag to prevent infinite loops
      return _this;
    }
    _createClass(QuantitySelector, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this2 = this;
        // Find all quantity badges within this component
        this.badges = Array.from(this.querySelectorAll('.product__quantity-badge'));

        // Find the quantity input in the form
        var form = this.closest('.form__wrapper');
        if (form) {
          this.quantityInput = form.querySelector('[name="quantity"]');
        }

        // Initialize event listeners for each badge
        this.badges.forEach(function (badge) {
          badge.addEventListener('click', _this2.onBadgeClick.bind(_this2));
        });

        // Set initial selection (first badge)
        if (this.badges.length > 0) {
          this.selectBadge(this.badges[0]);
        }
        this.checkAvailability();
        // Listen for theme variant change events
        document.addEventListener('theme:variant:change', function (event) {
          // Reset to first badge when variant changes

          _this2.checkAvailability();

          // if (selectedSellingPlan && selectedSellingPlan.value) {
          //   // Set quantity to 1
          //   if (this.quantityInput) {
          //     this.quantityInput.value = '1';
          //   }

          //   // Hide the quantity selector
          //   this.style.display = 'none';
          // }
          // else {
          //   // Show the quantity selector
          //   this.style.display = 'grid';

          //   // Reset to first badge
          //   if (this.badges.length > 0) {
          //     this.selectBadge(this.badges[0]);
          //   }
          // }
        });
      }

      /**
       * Handle badge click event
       * @param {Event} event - The click event
       */
    }, {
      key: "onBadgeClick",
      value: function onBadgeClick(event) {
        var badge = event.currentTarget;
        this.selectBadge(badge);
      }
    }, {
      key: "checkAvailability",
      value: function checkAvailability() {
        var _this3 = this;
        setTimeout(function () {
          var selectedSellingPlan = document.querySelector('product-sticky select[name="selling_plan_select"]');
          if (selectedSellingPlan && selectedSellingPlan.value) {
            if (_this3.quantityInput) {
              _this3.quantityInput.value = '1';
              // Don't call selectBadge here to avoid triggering pushState loop
              // Just update the visual state
              _this3.badges.forEach(function (b) {
                b.classList.remove('selected-quantity');
              });
              if (_this3.badges.length > 0) {
                _this3.badges[0].classList.add('selected-quantity');
                _this3.selectedBadge = _this3.badges[0];
              }
            }
            _this3.style.display = 'none';

            // Update product form state to reflect quantity change for subscription
            var productForm = document.querySelector('product-form');
            if (productForm && productForm.productForm) {
              var currentState = productForm.productForm.getFormState();
              productForm.pushState(currentState);
            }
          } else {
            _this3.style.display = 'grid';
          }
        }, 100);
      }

      /**
       * Select a badge and update the quantity input
       * @param {Element} badge - The badge element to select
       */
    }, {
      key: "selectBadge",
      value: function selectBadge(badge) {
        var _this4 = this;
        // Prevent infinite loops
        if (this.isUpdating) return;
        this.isUpdating = true;
        debugger;
        // Remove selected class from all badges
        this.badges.forEach(function (b) {
          b.classList.remove('selected-quantity');
        });

        // Add selected class to the clicked badge
        badge.classList.add('selected-quantity');
        this.selectedBadge = badge;

        // Update quantity input value
        var quantity = badge.getAttribute('data-quantity');
        if (this.quantityInput && quantity) {
          this.quantityInput.value = quantity;

          // Dispatch change event to notify other components
          // this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Update subscription prices based on discount percentage
        var percentageSaving = badge.getAttribute('data-percentage-saving');
        debugger;
        this.updateSubscriptionPrices(percentageSaving);

        // Dispatch custom event for other components to listen to
        // this.dispatchEvent(
        //   new CustomEvent('quantity:updated', {
        //     bubbles: true,
        //     detail: {
        //       quantity: quantity,
        //       badge: badge,
        //       percentageSaving: percentageSaving
        //     }
        //   })
        // );

        // Trigger the product form to update prices including the Add to Cart button
        var productForm = document.querySelector('product-form');
        if (productForm && productForm.productForm) {
          var currentState = productForm.productForm.getFormState();
          productForm.pushState(currentState);
        }

        // Reset the flag after a short delay
        setTimeout(function () {
          _this4.isUpdating = false;
        }, 200);
      }

      /**
       * Update subscription prices based on discount percentage
       * @param {string} percentageSaving - The discount percentage (e.g., "10", "15")
       */
    }, {
      key: "updateSubscriptionPrices",
      value: function updateSubscriptionPrices(percentageSaving) {
        var form = this.closest('.form__wrapper') || this.closest('form');
        if (!form) return;
        debugger;
        // Get base price from the selected badge's data-product-price attribute
        var basePriceText = this.selectedBadge ? this.selectedBadge.getAttribute('data-product-price') : null;
        if (!basePriceText) return;

        // Extract numeric price value
        var basePriceValue = parseFloat(basePriceText.replace(/[^0-9.]/g, ''));
        if (isNaN(basePriceValue)) return;

        // Find one-time purchase price element
        var oneTimePurchaseGroup = form.querySelector('[data-one-time-purchase]');
        if (!oneTimePurchaseGroup) return;
        var oneTimePurchasePrice = oneTimePurchaseGroup.querySelector('.product__subs__price');
        if (!oneTimePurchasePrice) return;

        // Update one-time purchase price with the pre-calculated and formatted price from data-product-price
        oneTimePurchasePrice.textContent = basePriceText;
      }

      /**
       * Get the current selected quantity
       * @returns {string} The selected quantity
       */
    }, {
      key: "selectedQuantity",
      get: function get() {
        return this.selectedBadge ? this.selectedBadge.getAttribute('data-quantity') : null;
      }
    }]);
    return QuantitySelector;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element if it's not already defined
  if (!customElements.get('data-quantity-selector')) {
    customElements.define('data-quantity-selector', QuantitySelector);
  }
}();

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;